import * as amplitude from "@amplitude/analytics-browser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import TagManager from "react-gtm-module";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AppRoutes } from "./appRoutes";
import { amplitudeKey, gaID } from "./common/config";
import { MentoroTheme } from "./shared/components/MentoroTheme/mentoroTheme";
import { appStore, persistor } from "./store";

if (gaID) {
  TagManager.initialize({
    gtmId: gaID,
    events: {
      want_to_achieve: "want_to_achieve",
      sign_up: "sign_up",
    },
  });
}

amplitude.init(amplitudeKey, {
  defaultTracking: false,
});

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 20,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ReduxProvider store={appStore}>
        <PersistGate persistor={persistor}>
          <MentoroTheme>
            <Router>
              <Switch>
                <AppRoutes />
              </Switch>
            </Router>
          </MentoroTheme>
        </PersistGate>
      </ReduxProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
}

export default App;
